import React from "react";
import services from "../../services";
import SearchFilter from "../filters/SearchFilter";
import TableHeader from "../common/table_header";
import TablePagination from "../common/TablePagination";
import Main from "../../Pages/Demo/main";
import Lang from "../../lang";
import TitleBar from "../common/title_bar";
import TlkTable from "../tlelrik/table/tlkTable";
var moment = require("moment");

const filters = {
    Tabs: {
        Audit: [
            {
                key: "operationDate",
                displayKey: "Data de operação",
                inputType: "RangePicker",
            },
            {
                key: "type",
                displayKey: "Module Type Search",
                inputType: "dropdown",
                option: [
                    { key: "Auditoria", value: "Auditoria" },
                    { key: "Fiscalização", value: "Fiscalização" },
                    { key: "Vindima", value: "Vindima" },
                    { key: "Parcela", value: "Parcela" },
                    { key: "Administração", value: "Administração" },
                    { key: "Conta Corrente", value: "Conta Corrente" },
                    { key: "Rótulos", value: "Rótulos" },
                    { key: "Convocatórias", value: "Convocatórias" },
                    { key: "Tesouraria", value: "Tesouraria" },
                    {
                        key: "Instalações Vínicas",
                        value: "Instalações Vínicas",
                    },
                    { key: "Marcas", value: "Marcas" },
                ],
            },
        ],
    },
    checkbox: [],
};

const columnkeyMap = {
    date: Lang.langCheck.langRequest("Date"),
    time: Lang.langCheck.langRequest("Time"),
    username: Lang.langCheck.langRequest("User"),
    module: Lang.langCheck.langRequest("módulo"),
    type: Lang.langCheck.langRequest("Type"),
    activity: Lang.langCheck.langRequest("Activity"),
};

class DashboardAudit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            telkikTable: "",
            tlkState: null,
            filterAuditData: [],
            totalcount: "0",
            SortBy: "id",
            SortType: false,
            Paginate: true,
            Page: 1,
            PageSize: 100,
            Filters: null,
        };
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        // this.createpayload();
    }

    createpayload = () => {
        let data = {
            Filters: this.state.Filters,
            SortBy: this.state.SortBy,
            IsSortTypeDESC: this.state.IsSortTypeDESC,
            IsPagination: this.state.Paginate,
            Page: this.state.Page,
            PageSize: this.state.PageSize,
        };
        this.getAuditList(data);
    };
    /*  Para obter a chave de filtros dos filtros personalizados para recuperar a API com base nisso */

    getFilters = (data) => {
        let Filters = {};
        console.log("data", data);
        if (data && data.filters && data.filters.type)
            Filters["Type"] = data.filters.type;
        this.setState(
            {
                Filters,
            },
            () => this.createpayload()
        );
    };

    handleFilter = (data) => {
        // let actionbuttons= {Edit:true,Redirect:false,Delete:true}
        // let telkikTable = <Main date={new Date()} list={data} notAction={true} actionbuttons={actionbuttons} columnlist={this.columnlist} ActionPerform={(action,id)=>this.ActionPerform(action,id)}/>
        this.setState(
            {
                telkikTable: null,
                filterAuditData: data,
            },
            () => this.createTabel()
        );
    };

    /*  Para excluir uma linha da base de dados no servidor */

    handleDelete = async (id) => {
        let res = await services.apiCall.requestApi(
            `User/Delete/${id}`,
            "post"
        );
        if (res) {
            //console.log("res",res)
            this.createpayload();
        }
    };

    updatelistsort = (sort, key) => {
        this.setState(
            {
                SortBy: key,
                SortType: sort,
            },
            () => this.createpayload()
        );
    };
    updatelistpagenumsize = (PageSize, page_num) => {
        this.setState(
            {
                Page: page_num,
                PageSize: PageSize,
            },
            () => this.createpayload()
        );
    };

    columnlist = Object.keys(columnkeyMap).map(function (key) {
        return { field: columnkeyMap[key], columnMenuType: "checkbox" };
    });

    createTabel = () => {
        let actionbuttons = { Edit: true, Redirect: false, Delete: true };
        //console.log("DATA",this.state.data);
        // let telkikTable = <Main date={new Date()} notAction={true} list={this.state.data} actionbuttons={actionbuttons} columnlist={this.columnlist} ActionPerform={(action,id)=>this.ActionPerform(action,id)}/>
        let telkikTable = (
            <TlkTable
                tlkState={this.state.tlkState}
                tableFilters={(filter) => this.tableFilters(filter)}
                date={new Date()}
                notAction={true}
                modulename={"auditList"}
                list={this.state.filterAuditData}
                actionbuttons={actionbuttons}
                columnlist={this.columnlist}
                ActionPerform={(action, id) => this.ActionPerform(action, id)}
            />
        );
        this.setState({
            telkikTable: telkikTable,
        });
    };

    tableFilters = (filter) => {
        let tlkState = { ...filter };
        let SortBy = "id";
        let IsSortTypeDESC = false;
        let columnkeyMaprev = {};
        for (var key in columnkeyMap) {
            columnkeyMaprev[columnkeyMap[key]] = key;
        }
        if (filter && filter.sort && filter.sort.length > 0) {
            SortBy = columnkeyMaprev[filter.sort[0].field];
            IsSortTypeDESC = filter.sort[0].dir === "asc" ? false : true;
        }
        this.setState(
            {
                Page: Math.ceil(filter.skip / filter.take) + 1,
                PageSize: filter.take || 100,
                SortBy,
                IsSortTypeDESC,
                tlkState,
            },
            () => {
                this.createpayload();
            }
        );
    };

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = (action, row) => {
        if (action == "Edit") {
            this.props.history.push({
                pathname: "/create_user",
                state: { user_id: row.id },
            });
        }
        // else if(action === 'Edit'){

        // }
    };

    getAuditList = async (data) => {
        let _r = await services.apiCall.requestApi(
            "/auditlog/getall",
            data,
            "post"
        );
        if (_r) {
            _r.map((_row, index) =>
                Object.keys(columnkeyMap).map(function (key) {
                    if (key === "date") {
                        _row[key] = moment(_row.date).format("DD-MM-YYYY");
                    } else if (key === "time") {
                        _row[key] = _row.time ? _row.time.split(".")[0] : "nd";
                    }
                    _row[columnkeyMap[key]] = _row[key];
                })
            );
            this.setState(
                {
                    data: _r,
                    filterAuditData: _r,
                    totalcount: window.localStorage.getItem("table_total"),
                },
                () => this.createTabel()
            );
        }
    };

    render() {
        return (
            <div className="inner-container">
                <div className="outer-space">
                    {/* <div className="row">
            <div className="col-md-8 order-sm-1 order-2">
                <div className="heading d-md-flex align-items-center">
                    <span className="sivdp-icon sivdp-auditing font-23 mr-3 ml-2 text-grey"></span>
                    <h3>{Lang.langCheck.langRequest("Audit")}</h3>
                    <button type="button" className="btn drop-down-black btn-primary dropdown-toggle" data-toggle="dropdown">
                    Opções
                    </button>
                    <div className="dropdown-menu">
                    <a className="dropdown-item" href="#">Opções</a>
                    <a className="dropdown-item" href="#">Opções</a>
                    <a className="dropdown-item" href="#">Opções</a>
                    </div>
                </div>
                <p className="custom-well">Início</p>
            </div>
            </div>  */}
                    <TitleBar
                        logo="auditing"
                        title={Lang.langCheck.langRequest("Audit")}
                    />
                    <SearchFilter
                        searchplaceholder="Selecione um critério de pesquisa junto aos filtros avançados"
                        showSearchDisabled={true}
                        handleFilter={(data) => this.handleFilter(data)}
                        data={this.state.data}
                        filters={filters}
                        getFilter={(data) => this.getFilters(data)}
                    />
                    {/* <h2 className="heading-table">Audit</h2>  */}
                    {/* <div className="white-box  mb40">
              <div className="row top-serch">
                  <div className="col-md-12 form-inline">
                    <div className="form-group ">
                      <input type="text" className="form-control" placeholder="Filter By Module" />
                    </div>
                  <div className="form-group">
                    <button className="btn btn-theme">APPLY</button>
                </div>
                <div className="form-group">
                  <button className="btn btn-black">CLEAR</button>
              </div>
                  </div>
                
                </div>
              </div>  */}

                    {/* <h2 className="heading-table">Audit Logs</h2>  */}
                    {this.state.totalcount > 0 && (
                        <div className="table-responsive table-section">
                            <h3>
                                {" "}
                                A pesquisa retornou {this.state.totalcount}{" "}
                                resultados{" "}
                            </h3>
                            {this.state.telkikTable}

                            {/* <table className="table table-hover">
                    <thead>
                      <tr>
                        <TableHeader columename='Activity' columnkey='activity' func={(sort,columnkey)=>this.updatelistsort(sort,columnkey)} />
                        <TableHeader className="text-center" columename='Type' columnkey='type' func={(sort,columnkey)=>this.updatelistsort(sort,columnkey)} />
                        <TableHeader className="text-center" columename='Time' columnkey='time' func={(sort,columnkey)=>this.updatelistsort(sort,columnkey)} />
                        <TableHeader className="text-center" columename='User' columnkey='userID' func={(sort,columnkey)=>this.updatelistsort(sort,columnkey)} />
                        <TableHeader className="text-center" columename='Date' columnkey='date' func={(sort,columnkey)=>this.updatelistsort(sort,columnkey)} />
                      </tr>
                    </thead>
                    <tbody>
                      {
                        this.state.data.map((_a,i)=>(
                          <tr>
                            <td>{_a.activity}</td>
                            <td>{_a.type}</td>
                            <td>{moment(_a.date).format("LTS")}</td>
                            <td>{_a.userID}</td>
                            <td>{moment(_a.date).format("DD-MM-YYYY")}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>  */}
                        </div>
                    )}
                    {this.state.totalcount < 1 && (
                        <div className="searct-found">
                            <img
                                className="img-fluid"
                                src="imgs/search-large-icon.png"
                                alt=""
                            />

                            <p className="font-14">
                                Efetue uma pesquisa para apresentação de
                                resultados
                            </p>
                        </div>
                    )}
                    {/* <div className="mb-4">
                  <TablePagination  totalcount={this.state.totalcount} PageSize={this.state.PageSize}  currentpage={this.state.Page} func={(PageSize, page_num)=>this.updatelistpagenumsize(PageSize, page_num)} />
                  </div>  */}
                </div>
            </div>
        );
    }
}

export default DashboardAudit;
